import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import {
  SectionHeading,
  Subheading as SubheadingBase,
} from "components/misc/Headings.js";
import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons.js";
import StatsIllustrationSrc from "images/stats-illustration.svg";
import { ReactComponent as SvgDotPattern } from "images/dot-pattern.svg";
import { BsBuildings } from "react-icons/bs";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";

const Container = tw.div`relative`;
const TwoColumn = tw.div`flex flex-col md:flex-row justify-between max-w-screen-xl mx-auto py-20 md:py-24`;
const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
const ImageColumn = tw(Column)`md:w-5/12 flex-shrink-0 h-80 md:h-auto relative`;
const TextColumn = styled(Column)((props) => [
  tw`md:w-7/12 mt-16 md:mt-0`,
  props.textOnLeft
    ? tw`md:mr-12 lg:mr-16 md:order-first`
    : tw`md:ml-12 lg:ml-16 md:order-last`,
]);

const Image = styled.div((props) => [
  `background-image: url("${props.imageSrc}");`,
  tw`rounded bg-contain bg-no-repeat bg-center h-full`,
]);
const TextContent = tw.div`lg:py-8 text-left md:text-left`;

const Subheading = tw(SubheadingBase)`text-center md:text-left`;
const Heading = tw(
  SectionHeading
)`mt-4 font-black text-left text-3xl sm:text-4xl lg:text-5xl text-center md:text-left leading-tight`;
const Description = tw.p`mt-4 md:text-left text-sm md:text-base lg:text-lg font-medium leading-relaxed text-secondary-100`;

const Statistics = tw.div`flex flex-col items-center sm:block text-center md:text-left mt-4`;
const Statistic = tw.div`text-left sm:inline-block sm:mr-12 last:mr-0 mt-4`;
const Value = tw.div`font-bold text-lg sm:text-xl lg:text-2xl text-secondary-500 tracking-wide`;
const Key = tw.div`font-medium text-primary-700`;

const PrimaryButton = tw(
  PrimaryButtonBase
)`mt-8 md:mt-10 text-sm inline-block mx-auto md:mx-0`;

const DecoratorBlob = styled(SvgDotPattern)((props) => [
  tw`w-20 h-20 absolute right-0 bottom-0 transform translate-x-1/2 translate-y-1/2 fill-current text-primary-500 -z-10`,
]);

export default ({
  subheading = "ABOUT US",
  heading = (
    <>
      Personal loans to fuel your <wbr />
      <span tw="text-red-500">dreams.</span>
    </>
  ),
  description = "Work with the best on the market.",
  primaryButtonText = "Learn More",
  primaryButtonUrl = "",
  imageSrc = StatsIllustrationSrc,
  imageCss = null,
  imageContainerCss = null,
  imageDecoratorBlob = false,
  imageDecoratorBlobCss = null,
  imageInsideDiv = true,
  statistics = null,
  textOnLeft = false,
}) => {
  return (
    <Container id="about-us">
      <TwoColumn css={!imageInsideDiv && tw`md:items-center`}>
        <ImageColumn css={imageContainerCss}>
          <Image imageSrc={"/imgs/experience.png"} css={imageCss} />
          <div tw="absolute left-[50%] top-0 -ml-20 pt-2 bg-primary-500 py-2 px-3 text-white flex items-center justify-center">
            <h2 tw="text-5xl !text-red-500 font-bold">10+</h2>
            <p tw="text-xs ml-2 font-bold">
              Years of <br /> experience
            </p>
          </div>
          <DecoratorBlob css={imageDecoratorBlobCss} />
        </ImageColumn>
        <TextColumn tw="px-5 lg:px-0" textOnLeft={textOnLeft}>
          <TextContent>
            {subheading && <Subheading>{subheading}</Subheading>}
            <Heading>{heading}</Heading>
            <div tw="flex items-center md:items-start gap-1 md:gap-3 mt-6">
              <BsBuildings size={80} />
              <h2 tw="text-lg md:text-2xl font-bold text-gray-800 text-gray-700">
                We provide the best financial services to individuals &
                businesses across Uganda.
              </h2>
            </div>
            <Description>{description}</Description>

            <div tw="mt-6 flex items-start justify-between gap-3 flex-col md:flex-row">
              <div>
                <div tw="flex items-center text-[18px] font-bold mt-4">
                  <IoMdCheckmarkCircleOutline
                    tw="text-red-500 font-bold mr-1"
                    size={23}
                  />
                  <h3>Swift loan approval.</h3>
                </div>
                <p>
                  After applying for a loan the approval process is almost
                  instant. We understand your needs & our key focus is to assist
                  you financially.
                </p>
              </div>

              <div>
                <div tw="flex items-center text-[18px] font-bold mt-4">
                  <IoMdCheckmarkCircleOutline
                    tw="text-red-500 font-bold mr-2"
                    size={23}
                  />
                  <h3>Quick loan disbursement.</h3>
                </div>
                <p>
                  After your loan has been approved, you get the money instant
                  to any convenient wallet, mobile money, cash & bank
                  disbursement.
                </p>
              </div>
            </div>
            {/* <PrimaryButton tw="" as="a" href={primaryButtonUrl}>
              {primaryButtonText}
            </PrimaryButton> */}
          </TextContent>
        </TextColumn>
      </TwoColumn>
    </Container>
  );
};
